import script from "./MsgOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgOverview.vue?vue&type=script&setup=true&lang=js"

import "./MsgOverview.vue?vue&type=style&index=0&id=329a9edd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329a9edd"]])

export default __exports__